<template>
  <WdsStack align-center gap-sm>
    <span
      v-if="selectedContacts.length === 0"
      class="circle circle40 circle-gray contacts-selected-circle"
    >
      <i class="fa fa-user" />
    </span>
    <WdsAvatarGroup v-if="avatars.length" :avatars="avatars" :max-avatars="maxAvatars" />
    <span class="tw-font-medium">
      {{ $tc(':count contacts selected', avatars.length) }}
    </span>
  </WdsStack>
</template>

<script>
import { WdsAvatarGroup, WdsStack } from '@worksome/wds-components'
import { getAvatarPath } from '@/utils/avatar'

export default {
  components: {
    WdsAvatarGroup,
    WdsStack,
  },
  props: {
    selectedContacts: { type: Array, default: () => [] },
    maxAvatars: {
      type: Number,
      default: 6,
      validator(value) {
        return value >= 0
      },
    },
  },
  computed: {
    avatars() {
      return this.selectedContacts.map((contact) => ({
        path: getAvatarPath(contact.avatar_path, contact.globalId),
        initials: contact.initials,
      }))
    },
  },
}
</script>

<style scoped lang="scss">
@import 'resources/sass/frontend/variable-overrides';
@import 'resources/sass/frontend/_color-variables';

.contacts-selected-circle {
  border: 2px solid $white;
  display: flex;
  align-items: center;
  justify-content: center;

  .fa-user {
    font-size: 26px;
  }
}
</style>
